import React, { Component, Fragment } from 'react';

import moment from 'moment';
import 'moment/locale/pt-br';

import { FaSearch } from 'react-icons/fa';

import { toaster } from 'evergreen-ui';
import api from '../../../services/api';

import ListTable from '../../../components/ListTableReports';
import { StyledBackofficeListReports } from './style/StyledBackofficeListReports';

import { ContentTitle } from '../../../components/utilities/styledComponents/ContentTitle';
import { StyledReportList } from './style/styledReportList';
import { LoaderFull } from '../../../components/Loader';

export default class UserList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchValue: '',
			elementsList: false,
			sort: '',
			withDate: '',
		};

		this.elementsData = {
			keys: [
				{
					col: 'company_name', title: 'Cliente', sort: true, id: 'company_name',
				},
				{
					col: 'pre_sale_id', title: 'ID Pré-venda', sort: true, id: 'pre_sale_id',
				},
				{
					col: 'document_number', title: 'CNJP:', sort: true, id: 'document_number',
				},
				{
					col: 'start_date_and_end_date', title: 'Data de início e de término', sort: false, id: 'start_date_and_end_date',
				},
				{
					col: 'template_name', title: 'Template', sort: false, id: 'template_name',
				},
				{
					col: 'edit_or_save', title: '', sort: false, id: 'edit_or_save',
				},
				{
					col: 'view', title: '', sort: false, id: 'view',
				},
			],
		};

		this.url = '/reports';
	}

	componentDidMount() {
		const { location } = this.props;

		if (location.state) {
			toaster.success(
				location.state.formMessage,
			);
		}

		this.getData(this.url);
	}

	handleChange = (event) => {
		this.setState({ sort: event.target.value }, this.searchReports);
	};

	toggleDate = () => {
		const { withDate } = this.state;

		if (withDate) {
			return this.setState({
				withDate: false,
			}, this.searchReports);
		}

		return this.setState({
			withDate: true,
		}, this.searchReports);
	};

	searchReports = () => {
		const {
			sort,
			withDate,
		} = this.state;

		let {
			searchValue,
		} = this.state;

		searchValue = searchValue.replace(/[.|/|-]/gm, '');

		api.get(`${this.url}?query=${searchValue}&data=${withDate}&sort=${sort}`)
			.then(response => this.setState({
				elementsList: this.buildObjectData(response.data.data),
			}));
	};

	enableEditReport = (id) => {
		const {
			elementsList,
		} = this.state;

		const filterElementsList = elementsList.map((item) => {
			if (item.id === id) {
				item.edit = true;
				item.edit_or_save = { action: 'save', name: 'Salvar' };
			}

			return item;
		});


		return this.setState({
			elementsList: filterElementsList,
		});
	};

	updateReport = (id, params) => {
		const {
			elementsList,
		} = this.state;

		const {
			startDate,
			endDate,
			template,
		} = params;

		const data = {
			start_date: startDate ? `${moment(startDate).format('YYYY-MM-DD')} 00:00:00` : '',
			end_date: endDate ? `${moment(endDate).format('YYYY-MM-DD')} 23:59:59` : '',
			report_template_id: template,
		};

		if ((moment(moment(startDate).format()).isAfter(moment(endDate).format()))) {
			return toaster.danger(
				'Data inicial menor que data final!',
			);
		}

		const filterElementsList = elementsList.map((item) => {
			if (item.id === id) {
				item.start_date_and_end_date.startDate = startDate;
				item.start_date_and_end_date.endDate = endDate;
				item.edit = false;
				item.edit_or_save = { action: 'edit', name: 'Editar' };
			}

			return item;
		});

		api.put(`${this.url}/${id}`, JSON.stringify(data))
			.then(() => toaster.success(
				'Relatório salvo com sucesso!',
			))
			.catch((error) => {
				if (error.response.status === 403) {
					return toaster.danger(
						'Ação não autorizada!',
					);
				}

				if (error.response.status === 404) {
					return toaster.danger(
						'Relatório não encontrado!',
					);
				}

				return toaster.danger(
					'Ops! Ocorreu um erro, tente novamente mais tarde.',
				);
			});

		return this.setState({
			elementsList: filterElementsList,
		});
	};

	checkFirstParam = params => (params ? '?' : '&');

	getUrlParams = () => {
		const {
			sort,
			withDate,
			searchValue,
		} = this.state;

		let params = '';

		if (sort) {
			params = params.concat(`${this.checkFirstParam}query=${searchValue}`);
		}

		if (sort) {
			params = params.concat(`${this.checkFirstParam}date=${withDate}`);
		}

		if (sort) {
			params = params.concat(`${this.checkFirstParam}sort=${sort}`);
		}

		return params;
	};

	getData = (url) => {
		api.get(`${url}${this.getUrlParams()}`)
			.then(response => this.setState({
				elementsList: this.buildObjectData(response.data.data),
			}))
			.catch(() => toaster.danger(
					'Ops! Ocorreu um erro, tente novamente mais tarde.',
				));
	};

	buildObjectData = values => values.map(data => (
			{
				id: data.id,
				company_name: data.attributes.company_name,
				pre_sale_id: data.attributes.pre_sale_id,
				document_number: data.attributes.document_number.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5'),
				start_date_and_end_date: {
					startDate: data.attributes.start_date ? moment(data.attributes.start_date) : '',
					endDate: data.attributes.end_date ? moment(data.attributes.end_date) : '',
				},
				template_name: data.attributes.template_name,
				edit_or_save: { action: 'edit', name: 'Editar' },
				view: { action: 'view', name: <FaSearch />, link: 'relatorios' },
				edit: false,
			}
		));

	render() {
		const {
			elementsList, sort, searchValue, withDate,
		} = this.state;

		if (!elementsList) {
			return (
				<LoaderFull />
			);
		}

		return (
			<Fragment>
				<ContentTitle className="d-flex justify-content-between">
					Listagem de Relatórios
				</ContentTitle>

				<StyledReportList>
					<header>
						<i className="fa fa-bullhorn" />
						<strong>Relatórios</strong>
					</header>

					<form>
						<label htmlFor="searchReports">Buscar:</label>
						<input id="searchReports" className="d-block w-100" value={searchValue} onChange={(e) => { this.setState({ searchValue: e.target.value }, this.searchReports.bind(this)); }} />
					</form>

					<StyledBackofficeListReports>
						<div className="row mt-4">
							<div className="container-form">
								<label>Visualizar relatórios por:</label>

								<button type="button" className={`btn ${withDate === false ? '' : 'active'}`} onClick={this.toggleDate.bind(this)}>Sem data</button>

								<button type="button" className={`btn ${withDate === true ? '' : 'active'}`} onClick={this.toggleDate.bind(this)}>Com data</button>
							</div>
						</div>

						<div className="row mt-4">
							<div className="container-form">
								<label htmlFor="orderReport">Ordenar por:</label>

								<select className="form-control" id="orderReport" value={sort} onChange={this.handleChange.bind(this)}>
									<option className="muted">Data</option>
									<option value="start_date:desc">Data de início - Maior</option>
									<option value="start_date:asc">Data de início - Menor</option>
									<option value="end_date:desc">Data de término - Maior</option>
									<option value="end_date:asc">Data de término - Menor</option>
								</select>
							</div>
						</div>
					</StyledBackofficeListReports>

					<ListTable
						keys={this.elementsData.keys}
						funcUpdate={this.updateReport}
						funcEdit={this.enableEditReport}
						elements={elementsList}
						changeSorting={this.changeSorting}
						sort={sort}
					/>
				</StyledReportList>
			</Fragment>
		);
	}
}
